module.exports = __webpack_public_path__ + "img/left-right-arrow.ff6ac341.png";